import { Environment } from "./Environment";

export const Master = new Environment("master", {
  debug: false,
  apiBase: "https://api.serverready.io",
  appBasePath: "https://app.serverready.io",
  appDomain: "app.serverready.io",
  cookieDomain: ".serverready.io",
});
